module.exports = __webpack_public_path__ + "img/popuaudio.4cda267c.svg";